export enum CONTRACT_STATUS {
  UNKNOWN = "-1",
  SIGN = "1",
  UNSIGN = "0",
  CANCEL = "2",
  APPLE_AUTH_NOT_MATCH = "5", // 签约失败
  APPLE_AUTH_NOT_MATCH_INVALID = "6" // 此身份信息已绑定其他 Apple ID
}
export const HOME_PAGE_LAST_BUY_TAB = {
  QB: "QB",
  APPLE_GIFT_CARD: "APPLE_GIFT_CARD"
}

export const CONTRACT_STATUS_COPYWRITING = {
  "5": "很遗憾，你暂不能继续充值，请核对微信实名信息是否已绑定其他Apple ID",
  "6": "您的身份证已关联其他Apple ID，请使用原有Apple ID。如需协助，请联系Apple：400-666-8800",
  error: "查询签约状态异常，请重试！"
}
